<template>
    <div class="pagination">
        <ul class="v-pagination theme--light pageSizeControl">
            <li>{{$t('Rows per page')}}</li>
            <li><v-select
                    class="pagination"
                    v-model="selectedPageSize"
                    :items="pageSizes"
                    v-on:input="changePageSize"
            /></li>
        </ul>
        <v-pagination
            v-model="currentPage"
            :length="pageCount"
            :total-visible="visibleButtons"
        />
        <ul class="v-pagination theme--light pageGoto">
            <li>{{$t('Go to page')}}</li>
            <li><v-select
                    class="pagination"
                    :items="pages"
                    v-on:input="goToPage"
            /></li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: "Pagination",
        props: {
            pageCount: Number,
            pageSize: {
                type:    Number,
                default: 100
            },
            visibleButtons: {
                type:    Number,
                default: 7
            },
            value: Number
        },
        data() {
            return {
                currentPage: this.value,
                selectedPageSize: this.pageSize,
                pageSizes: [
                    50,
                    100,
                    200,
                    500
                ]
            }
        },
        watch: {
            currentPage: function() {
                this.$emit('input', this.currentPage);
            }
        },
        methods: {
            goToPage(target) {
                if (
                    target !== this.currentPage
                    && target !== '...'
                ) {
                    if (target > this.pageCount) {
                        target = this.pageCount;
                    }
                    if (target < 1) {
                        target = 1;
                    }
                    this.$emit('input', target);
                    this.currentPage = target;
                }
            },
            changePageSize(pageSize) {
                this.$emit('pageSizeChange', pageSize)
            }
        },
        computed: {
            pages() {
                let pages = [];
                for (let page = 1; page <= this.pageCount; page++) {
                    pages.push(page);
                }
                return pages;
            }
        }
    }
</script>

<style>
    ul.pageSizeControl {
        vertical-align: bottom;
        margin-right: 16px;
    }
    ul.pageGoto {
        vertical-align: bottom;
        margin-left: 16px;
    }
    ul.pageSizeControl > li:first-child,
    ul.pageGoto > li:first-child {
        height: 40px;
    }
    div.pagination {
        margin: 0;
        padding: 0 16px;
    }

    div.pagination > div.v-input__control {
        width: 60px;
        border-bottom: 1px solid;
        padding: 9px 0 0 0;
    }
    div.pagination > div.v-input__control > div.v-input__slot[role="button"] {
        margin: 0;
    }
    div.pagination > div.v-input__control > div.v-input__slot[role="button"] > div.v-select__slot > div.v-select__selections > div.v-select__selection.v-select__selection--comma {
        margin: 3px 0 3px 4px;
    }
    div.pagination > div.v-input__control > div.v-input__slot[role="button"] > div.v-select__slot > div.v-select__selections > input {
        padding: 0;
    }

    div.pagination > div.v-input__control > div.v-input__slot[role="button"] > div.v-select__slot > div.v-input__append-inner {
        margin-top: 0;
    }

    div.pagination > div.v-input__control > div.v-text-field__details {
        min-height: 0;
    }

    div.pagination > div.v-input__control > div.v-text-field__details > div.v-messages.theme--light {
        min-height: 0;
    }

    div.pagination > nav[role="navigation"] {
        display: inline-block;
    }
</style>